import  gql  from 'graphql-tag'

export const methodologicalPillars = gql`query {
    methodologicalPillars{
        edges{
            node{
                id
                name
                acronym
                order
                methodologicalpillarquestionSet{
                    edges{
                        node{
                            id
                            statement
                            yesPercent
                            notPercent
                            pillar {
                                id
                            }
                        }
                    }
                }
            }
        }
    }
}`;
